/* ---------------------------------------------------------------
	READY
 --------------------------------------------------------------- */
$(document).ready(function(){                     	
	// INIT VARIABLE
	let dataModuleElementId = $("#info_page").attr('data-module-element-id')
	let pageSection = $("#info_page").attr('data-page-section')
			
	if(pageSection){
		$("#module_section").html(pageSection)
	}else{
		$("#module_section").html("*** SECTION ***")
	}

	if(dataModuleElementId){
		$("#module_element_id").html(dataModuleElementId)
	}else{
		$("#module_element_id").html("*** ID ***")
	}

	console.log('section : ' + pageSection)
	// END INIT VARIABLE


	switch(pageSection){
		case "index":
			pageSectionIndex()
			break;
	}

});
/* ---------------------------------------------------------------
	INDEX
 --------------------------------------------------------------- */
 	function pageSectionIndex(){
		
		$('#modal_candidature').on('show.bs.modal', function (e) {
			let emailCandiat = $("#fml_ins_recrutement input[name=email]").val()
			console.log(emailCandiat)
			$("#email_candidat").html(emailCandiat)
		})
		$('#modal_candidature').on('hide.bs.modal', function (e) {
			document.location.reload(true)
		})
		
		if($("#fml_ins_recrutement").length > 0){
			let formId = "#fml_ins_recrutement"
	
			$(formId).validate({
				rules: {
					email:{
						remote: {
							url: urlAjax.recrutement + "check_email.php",
						    type: "post",
						    data: {
						    	email: function() {
						        	return $( "input[name=email]" ).val()
						        }
						    }
						}				 
					}
				},
				messages: {
					email: { 
						remote: 'Adresse Email déjà enregistrée. Cliquez <a style="color:black;" href"#" data-toggle="modal" data-target="#modal_candidature">ICI</a> pour continuer votre candidature avec cette adresse email'
					}
				},				
				submitHandler: function(form) {
					var options = { 
						url: urlAjax.recrutement + "ins.php", 
						type: 'POST', dataType: 'json',
						beforeSubmit: function(){ 		
							ladForm.ladda( 'start' );
						},
						success: function(json){
							if(json){
								$("#fml_ins_recrutement").hide()
								$("#alert_success").show();
							}
							//window.location = "/intervenant/information/generale";					
						}
					};
					$(formId).ajaxSubmit(options);
					return false;
				}
			});
	
		}

 	}
// -------------------------------------------------------------
